<template>
  <section id="section-counselors">
    <div class="container">
      <div class="title-line">Mạng lưới Cố vấn</div>
      <div class="col-md-12 sub-title">
        Sự đa dạng về lý lịch, vị trí địa lý, ngành học, công việc của Cố vấn giúp khách hàng có nhiều lựa chọn
      </div>
      <div class="list_counselor_elements col-md-12 row">
        <div v-for="counselor in list_counselor_on_hompage" class="col-lg-3 col-md-4 col-sm-6 col-xs-12 counselor-element" >
          <div class="counselor-element-container card card-lift--hover shadow border-0">
            <a :href="'/counselor?id='+counselor.id">
              <img :src="counselor.avatar">
            </a>
            <div class="info_counselor">
              <div class="name">{{counselor.name}}</div>
              <div class="title">{{counselor.counselor_title}}</div>
              <div class="university">
                <i class="fa fa-graduation-cap"></i>
                <span>{{counselor.degree[0].major}} tại <strong>{{counselor.degree[0].university}}</strong></span> 
              </div>
              <div class="address"><i class="fa fa-map-marker"></i> {{counselor.address}}</div>
            </div>          
            <div class="bottom-element">
              <a :href="'/counselor?id='+counselor.id">Xem chi tiết <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>        
        </div>
      </div>
      <div class="margin_top_button btn-wrapper">
        <a
         class="btn button color_button mb-3 mb-sm-0"
         href="/doi-ngu-tu-van">
            Xem thêm
        </a>                      
      </div>
    </div>
  </section>
</template>
<script>
import {mapActions, mapState} from "vuex";
export default {
  computed: {
    ...mapState('vuex_homepage', [
        'list_counselor_on_hompage'
    ])
  }
};
</script>
<style lang="scss" scoped>
  @import './counselors';
</style>



// WEBPACK FOOTER //
// src/views/components/HomePage/Counselors.vue